export default "__VITE_ASSET__41d90784__"